export const COLOR_BLACK = 'color-black';
export const COLOR_RED = 'color-red';
export const COLOR_GREEN = 'color-green';
export const COLOR_GRAY = 'color-gray';
export const BACKGROUND_GRAY = 'bg-gray';
export const ICON_RED = 'icon-red';
export const ICON_GREEN = 'icon-green';
export const COLOR_BLUE = 'color-blue';
export const COLOR_ORANGE = 'color-orange';
// Klasy zdefiniowane w table-styles.scss (razem z wariantami dla zaznaczenia i hovera).
export const ROW_INCOMPLETE = 'row-incomplete';
// Dwa stopnie przygaszenia wiersza o starych danych. Przygaszają tylko treść i nie ruszają tła - tło
// niesie osobny kanał (klasy vc-*, patrz vehicle-color-source.ts).
export const ROW_OLD_POSITION = 'row-old-position';
export const ROW_EXPIRED_POSITION = 'row-expired-position';

export declare type ElementCssClassCreator<T> = (data: T) => string;

export interface TableElementFormatter<T> {
  createElementCssClasses: ElementCssClassCreator<T>;
}

export interface TableElementFormatterCollection<T> {
  [key: string]: TableElementFormatter<T>;
}
